import { isEmpty } from 'lodash';
import { UserPermissionsType, PermissionObjectType, AnyFunction } from '../../types/Permission';
import { disabledFunction } from '../Drawer/utils';
import { doesHavePermission } from './utils';

export default function PermissionFunctionWrapper(
  Func: AnyFunction,
  permissionObject?: PermissionObjectType,
  userPermissions?: UserPermissionsType,
) {
  return function FunctionWrappedWithPermissions(...args: any[]) {
    const { allowedPermissions = [], disallowedPermissions = [] } = userPermissions || {};
    const { requiredPermissions = {} } = permissionObject || {};
    const {
      interactPermissions = [],
    } = requiredPermissions;

    if (isEmpty(interactPermissions)) {
      return Func(...args);
    }

    const doesHaveInteractPermissions = doesHavePermission(
      interactPermissions,
      allowedPermissions,
      disallowedPermissions,
    );

    if (!doesHaveInteractPermissions) {
      return disabledFunction();
    }

    return Func(...args);
  };
}
